import { Box, styled, Table as MUITable, Typography } from '@mui/material';

import { Icon } from '../Icon';

export const SectionTerms = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'withoutBottomRadius',
})(({ theme, withoutBottomRadius }) => ({
  width: '100%',
  alignSelf: 'stretch',
  padding: `${theme.spacing(12)} ${theme.spacing(20)} ${theme.spacing(15)}`,
  borderRadius: '64px',
  borderBottomLeftRadius: withoutBottomRadius ? 0 : 64,
  borderBottomRightRadius: withoutBottomRadius ? 0 : 64,
  marginTop: theme.spacing(6),
  lineHeight: '27px',
  b: {
    fontWeight: 500,
  },
  strong: {
    fontWeight: 700,
  },
  [theme.breakpoints.down('lg')]: {
    padding: `${theme.spacing(10)} ${theme.spacing(15)}`,
  },
  [theme.breakpoints.down('md')]: {
    borderRadius: '100px',
    borderBottomLeftRadius: withoutBottomRadius ? 0 : 64,
    borderBottomRightRadius: withoutBottomRadius ? 0 : 64,
  },
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(8)} ${theme.spacing(4)}`,
    marginTop: theme.spacing(8),
  },
  [theme.breakpoints.down(450)]: {
    '& a': {
      fontSize: 15,
    },
  },
  [theme.breakpoints.down(375)]: {
    '& a': {
      fontSize: 12,
    },
  },
}));

export const PageTitle = styled('h2')(() => ({
  width: '100%',
  margin: 0,
  fontSize: 48,
  fontWeight: 600,
  lineHeight: 1.2,
  textAlign: 'center',
}));

export const About = styled(Box)(({ theme }) => ({
  '& p:first-of-type': {
    marginBottom: theme.spacing(3),
  },
}));

export const SectionTitle = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.35,
  textAlign: 'left',
}));

export const PrivacySectionTitle = styled(Typography)(() => ({
  fontSize: 20,
  fontWeight: 500,
  lineHeight: 1.35,
  textAlign: 'left',
}));

export const Table = styled(MUITable)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(6),
  borderCollapse: 'collapse',
  tableLayout: 'fixed',

  '& tbody tr': {
    verticalAlign: 'top',
  },

  '& th': {
    width: '30%',
    maxWidth: 320,
    padding: `${theme.spacing(4.5)} ${theme.spacing(3)} ${theme.spacing(4.5)} 0`,
    textAlign: 'left',
    verticalAlign: 'top',
    fontWeight: 700,
    backgroundColor: 'transparent !important',
    border: 'none',
    borderRadius: '0 !important',
  },

  '& td': {
    width: '70%',
    padding: `${theme.spacing(4.5)} 0`,
    verticalAlign: 'top',
    textAlign: 'left',
    border: 'none',
  },

  '& tbody tr:first-of-type th': {
    paddingTop: theme.spacing(3),
  },

  '& tbody tr:first-of-type td': {
    paddingTop: theme.spacing(3),
  },

  '& ul': {
    margin: 0,
    paddingLeft: '1.2rem',
  },

  '& li + li': {
    marginTop: theme.spacing(2),
  },

  [theme.breakpoints.down('md')]: {
    tableLayout: 'auto',

    '& tbody, & tr, & th, & td': {
      display: 'block',
      width: '100%',
    },

    '& th': {
      maxWidth: 'none',
      padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1.5)}`,
      borderRadius: '12px',
      backgroundColor: '#121b22 !important',
    },

    '& td': {
      padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(3)}`,
    },

    '& tr + tr': {
      marginTop: theme.spacing(2),
    },
  },
}));

export const TermsTable = styled(Table)(({ theme }) => ({
  borderCollapse: 'separate',
  borderSpacing: 0,

  '& th': {
    backgroundColor: 'rgb(18, 27, 34) !important',
    paddingTop: '24px',
    paddingLeft: '24px',
    borderRadius: '0 !important',
  },

  '& tbody tr:first-of-type th': {
    borderTopLeftRadius: '24px !important',
    borderTopRightRadius: '24px !important',
    paddingTop: '24px',
    paddingLeft: '24px',
  },

  '& tbody tr:last-of-type th': {
    borderBottomLeftRadius: '24px !important',
    borderBottomRightRadius: '24px !important',
  },

  [theme.breakpoints.down('md')]: {
    '& tbody tr:first-of-type th': {
      borderRadius: '12px !important',
    },

    '& tbody tr:last-of-type th': {
      borderBottomLeftRadius: '12px !important',
      borderBottomRightRadius: '12px !important',
      borderTopLeftRadius: '0 !important',
      borderTopRightRadius: '0 !important',
    },
  },
}));

export const PrivacyTable = styled(TermsTable)(() => ({
  '& td': {
    paddingLeft: '20px',
  },
}));

export const Link = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(5),
  gap: theme.spacing(),
}));

export const LinksIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.color.fg.tetriary,
  marginBottom: theme.spacing(1.2),
}));
